import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-invoice-actions-quote',
  templateUrl: './invoice-actions-quote.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InvoiceActionsQuoteComponent {
  @Input() canGenerate = false;

  @Output() generateSalesOrder = new EventEmitter<void>();
  @Output() generateInvoice = new EventEmitter<void>();
}
